import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
//router
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
//store
import { Provider } from 'react-redux';
//reducer
import { store } from './store';

import { IndexRouters } from './router';
import { SimpleRouter } from './router/simple-router';
import { ChatRouter } from './router/chat-router';
import toast, { Toaster } from 'react-hot-toast';
import  { ProjectNameProvider } from '../src/Context/ProjectNameContext'
// Google OAuth
import { GoogleOAuthProvider } from '@react-oauth/google';
import LoginRedirect from './views/dashboard/auth/LoginRedirect';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { UserProvider } from './Context/UserContext';
import { LogoLinkProvider } from './Context/LogoLinkContext';
import { ConnectionProvider } from './Context/ConnectionContext';
// Create the router and add the LinkedIn redirect route
const router = createBrowserRouter([
  ...IndexRouters,
  ...SimpleRouter,
  ...ChatRouter,
  {
    path: '/login-redirect',
    element: <LoginRedirect />,
  },
], { basename: process.env.PUBLIC_URL });

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <I18nextProvider i18n={i18n}>
      <ProjectNameProvider>
      <LogoLinkProvider>
      <ConnectionProvider>
        <UserProvider>
        <RouterProvider router={router} >
                  <App />
                </RouterProvider>
        </UserProvider>
        </ConnectionProvider>
        </LogoLinkProvider>
      </ProjectNameProvider>
      <Toaster position="top-right" reverseOrder={false}/>
      </I18nextProvider>
  </GoogleOAuthProvider>
</Provider>
);
